import {
    Checkbox,
    FormLabel,
    InputList,
    Textinput
} from "shared";
import {
    ITemplateComponent,
    ITemplateTableComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import styles from "./component_form_table.module.scss";

interface IComponentFormTableProps {
    component: ITemplateTableComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    triggerValidate: number;
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormTable: React.FC<IComponentFormTableProps> = React.memo(({
                                                                                      component,
                                                                                      enLanguageEnabled,
                                                                                      componentList,
                                                                                      triggerValidate,
                                                                                      onChange
                                                                                  }) => {
    const t = useComponentsTranslations();
    const { validateTag, validateTableList } = useComponentValidateFunction();

    const onFieldChange = (value: Partial<ITemplateTableComponent>) => {
        onChange({
            ...component,
            ...value
        })
    };


    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>

        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={validateTag}
                       value={component.name ? component.name : ""}
                       onChange={(e) => onFieldChange({ name: e.target.value })}
                       view="outline"/>
            <div className={styles.subLabel}>{t("tableTagSubLabel")}</div>
        </FormLabel>

        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("drawHeader")}
                size="m"
                onChange={() => onFieldChange({ drawHeader: typeof component.drawHeader === "boolean" ? !component.drawHeader : false })}
                checked={typeof component.drawHeader === "boolean" ? component.drawHeader : true}
            />
        </div>

        <FormLabel title={t("listOfColumns")}>
            <InputList
                listId={component.id}
                list={component.list}
                list_en={component.list_en}
                triggerValidate={triggerValidate}
                validate={true}
                validateFunc={validateTableList}
                enLanguageEnabled={enLanguageEnabled}
                onChange={options => onFieldChange({
                    list: options.map((o) => o.value),
                    list_en: options.map((o) => o.value_en)
                })
                }
            />
        </FormLabel>

        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>

        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />

        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("requiredField")}
                size="m"
                onChange={() => onFieldChange({ required: typeof component.required === "boolean" ? !component.required : false })}
                checked={typeof component.required === "boolean" ? component.required : true}
            />
        </div>

    </div>;
});

